<script setup lang="ts">
import { ProductCategoryLink } from "~/templates/partials/navigation/ProductCategoryLink";
import { ProductOverviewLink } from "~/templates/partials/navigation/ProductOverviewLink";
import { filterNodesByType, mapNodes } from "~/utils/helper/magnolia";

export interface ProductOverviewListProps {
  level: object; // todo: correct type needs to be defined
}

const { level } = defineProps<ProductOverviewListProps>();

const links = computed(() => filterNodesByType(mapNodes(level), "nav:"));
</script>

<template>
  <ul class="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
    <li v-for="link in links" :key="link['@id']" class="grid">
      <ProductCategoryLink
        v-if="link['@nodeType'] === 'nav:productlink'"
        :image="link.image"
        :link="link.link"
      />
      <ProductOverviewLink
        v-if="link['@nodeType'] === 'nav:linkbox'"
        :link="link.groupLink"
        :text="link.groupText"
      />
    </li>
  </ul>
</template>
